<template>
  <header class="header">
    <div class="header__left">
      <div class="header__logo">
        <nuxt-link :to="{ name: 'index' }">
          <img class="" src="/frontend/img/logo-c.svg" srcset="/frontend/img/logo-c.svg 1x, /frontend/img/logo-c.svg 2x" alt="会社手続きナビゲーター モチカケ">
        </nuxt-link>
      </div>
    </div>
    <div class="header__right">
      <div class="header__button" :class="{ open: menuIsOpen }" @click="menuToggle">
        <span></span>
        <span></span>
        <p>メニュー</p>
      </div>
      <div class="header__menu" :class="{ open: menuIsOpen }">
        <ul>
          <li><nuxt-link to="/function">機能</nuxt-link></li>
          <!-- <li><nuxt-link to="#price">料金プラン</nuxt-link></li> -->
          <li><nuxt-link to="/contact">お問い合わせ</nuxt-link></li>
          <li><nuxt-link to="/resources">お役立ち資料</nuxt-link></li>
          <li><nuxt-link to="/auth/login">ログイン</nuxt-link></li>
          <li class="register"><nuxt-link class="button button--menu" to="/auth/register">無料ではじめる<i class="las la-chevron-circle-right"></i></nuxt-link></li>
        </ul>
      </div>
    </div>
</header>
</template>

<script>
  export default {
    name: 'f-header-lp',
    data: () => ({
      menuIsOpen: false
    }),
    mounted() {
      window.addEventListener('resize', this.handleResize);
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.handleResize)
    },
    watch: {
        '$route' () {
            this.menuIsOpen = false;
        }
    },
    methods: {
      menuToggle() {
        this.menuIsOpen = !this.menuIsOpen;
      },
      handleResize() {
        if (window.innerWidth < 960) {
          this.menuIsOpen = false;
        } else {
          this.menuIsOpen = true;
        }
      },
    }
  }
</script>
